module.exports = __webpack_public_path__ + "media/2.3c761e34.mp3";